import { FunctionalComponent, h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import * as appStyles from '../../../assets/global.scss';
import Icon from '../../../common/Icon/Icon';
import { actions, Actions, BookingState, connectWithStyles } from '../../../store';
import { Properties, TravelType } from '../../../common';
import { WithStyles } from '../../../style';
import { FinText } from '../../../i18n';

export interface TravelTypeRadioProps extends Properties {
  value: TravelType;
  selected: boolean;
  onCheck: (travelType: TravelType) => void;
}

interface StoreProps {
  enableAutoFocus: boolean;
}

type EffectiveProps = TravelTypeRadioProps & StoreProps & Actions & WithStyles;

const mapStateToProps = ({ enableAutoFocus }: BookingState): StoreProps => ({
  enableAutoFocus,
});

const TravelTypeRadio: FunctionalComponent<TravelTypeRadioProps> = connectWithStyles<TravelTypeRadioProps>(
  [appStyles],
  {
    mapStateToProps,
    actions,
  }
)(({ selected, value, tx, onCheck, enableAutoFocus }: EffectiveProps) => {
  const input = useRef(null);

  useEffect(() => {
    if (selected && enableAutoFocus) {
      input.current && input.current.focus();
    }
  }, [selected, enableAutoFocus]);

  return (
    <label
      for={`travelType-${value}`}
      class={tx(
        'nordic-blue-900-text block relative mr-xxsmall-y ms-xsmall-l ms-medium-r medium-type link-hover nowrap'
      )}
      onClick={() => onCheck(value)}
    >
      <input
        ref={input}
        class={tx('is-vishidden')}
        type="radio"
        name="travelType"
        value={value}
        checked={selected}
        autofocus={enableAutoFocus && selected}
      />
      <Icon
        class={tx('is-small nordic-blue-900-text')}
        iconName={selected ? 'radiobutton-selected' : 'radiobutton-unselected'}
      />
      <span class={tx('ms-xsmall-l')}>
        <FinText id={`travelType.${value}`} />
      </span>
    </label>
  );
});
export default TravelTypeRadio;
